import { ApiResponse, Navigation } from 'app/shared/models';
import { Observable, ReplaySubject, shareReplay, tap } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { FuseNavigationItem } from '@fuse/components/navigation';

import { HttpClientService } from '../data/http-client.service';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private _httpClient = inject(HttpClientService);
  private _navigation: ReplaySubject<Navigation> =
    new ReplaySubject<Navigation>(1);
  private _navigationRequest: Observable<
    ApiResponse<FuseNavigationItem[]>
  > | null = null;
  private _navigationToken: string | null = null;

  get navigation$(): Observable<Navigation> {
    return this._navigation.asObservable();
  }

  get(forceRefresh: boolean = false): Observable<
    ApiResponse<FuseNavigationItem[]>
  > {
    const currentToken = localStorage.getItem('passport');

    if (
      !forceRefresh &&
      this._navigationRequest &&
      currentToken === this._navigationToken
    ) {
      return this._navigationRequest;
    }

    this._navigationToken = currentToken;
    this._navigationRequest = this._httpClient
      .get<ApiResponse<FuseNavigationItem[]>>('/webapp/menus')
      .pipe(
        tap((navigation) => {
          const items = navigation.data ?? [];

          this._navigation.next({
            default: items,
            compact: [],
            horizontal: items,
            futuristic: [],
          });
        }),
        shareReplay({ bufferSize: 1, refCount: false })
      );

    return this._navigationRequest;
  }

  clearCache(): void {
    this._navigationRequest = null;
    this._navigationToken = null;
  }
}
